export default function CarrierCompletedShipment() {

  return (
      <p>حمل های تکمیل شده</p>
  );
};